<div class="editar-dados-cliente">

  <div class="row">
    <div *ngIf="!!imageUser || !!fileUpload; then photo else noPhoto"></div>
    <ng-template #photo>
      <div class="col-12 text-center mb-4">
        <p-avatar [image]="fileUpload|| imageUser" class="justify-content-center"
          [style]="{'height': '200px', 'width': '200px'}" size="xlarge" shape="circle" />
      </div>
    </ng-template>
    <ng-template #noPhoto>
      <div class="col-12 text-center mb-4">
        <i class="fa-solid fa-user text-secondary rounded-circle bg-light justify-content-center"
          [style]="{'width': '200px', 'height': '200px', 'overflow': 'hidden'}"></i>
      </div>
    </ng-template>
    <div class="d-flex w-100 justify-content-center text-center mb-4">
      <p-toast></p-toast>
      <p-fileupload mode="basic" class="mr-2" name="demo[]" chooseIcon="pi pi-upload" (onSelect)="onSelect($event)" accept="image/*"
        maxFileSize="5000000" [auto]="true" [chooseLabel]="'editar_foto' | transloco"></p-fileupload>

      <p-button [label]="'remover_foto' | transloco" severity="secondary" icon="pi pi-times" (click)="removePhoto()"
        *ngIf="fileUpload || imageUser"></p-button>
    </div>
  </div>

  <form [formGroup]="clienteFormGroup" autocomplete="off">
    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup" descricao="{{'cpf_cnpj' | transloco}}" autoPreenchimento="off"
          nomeControle="cpf_cnpj" mascara="000.000.000-00||00.000.000/0000-00" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup"
          [descricao]="tipoPessoa === 'F' ? ('nome' | transloco) : 'Razão social'" autoPreenchimento="off"
          nomeControle="nome" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row" *ngIf="tipoPessoa === 'J'">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup" descricao="Nome do contato principal" autoPreenchimento="off"
          nomeControle="nome_contato" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup"
          [descricao]="tipoPessoa === 'F' ? ('celular' | transloco) : 'Celular do contato principal'"
          autoPreenchimento="off" nomeControle="telefone" mascara="(00) 00000-0000" classe="horizontal-100"></app-campo>
      </div>

      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup"
          [descricao]="tipoPessoa === 'F' ? ('email' | transloco) : 'Email do contato principal'"
          autoPreenchimento="off" nomeControle="email" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <span *ngIf="tipoPessoa === 'J'">
      <div class="row">
        <div class="col-xl-6">
          <app-campo [formulario]="clienteFormGroup" descricao="Inscrição municipal" autoPreenchimento="off"
            nomeControle="inscricao_municipal" classe="horizontal-100"></app-campo>
        </div>

        <div class="col-xl-6">
          <app-campo [formulario]="clienteFormGroup" descricao="Inscrição estadual" autoPreenchimento="off"
            nomeControle="inscricao_estadual" classe="horizontal-100"></app-campo>
        </div>
      </div>
    </span>

    <div class="row" *ngIf="tipoPessoa === 'F'">
      <div class="col-xl-6">
        <app-campo [formulario]="clienteFormGroup" descricao="{{'documento_rg_cnh_rne' | transloco}}"
          autoPreenchimento="off" nomeControle="documento" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-6">
        <app-opcoes [danger]="danger" [formulario]="clienteFormGroup" [requerido]="true" nomeControle="tipo_documento"
          identificacao="{{'tipo_documento' | transloco}}" [opcoes]="tiposDocumento"
          [textoAjuda]="!clienteFormGroup.controls['tipo_documento']?.value ? ('escolha_tipo_documento' | transloco) : ''">

        </app-opcoes>
      </div>
    </div>

    <div class="row" *ngIf="tipoPessoa === 'F'">
      <div class="col-xl-6">
        <app-opcoes [danger]="danger" [formulario]="clienteFormGroup" [requerido]="true" nomeControle="genero"
          identificacao="{{'genero' | transloco}}" [opcoes]="generos"
          [textoAjuda]="!clienteFormGroup.controls['genero']?.value ? ('escolha_genero' | transloco) : ''">

        </app-opcoes>
      </div>
    </div>
  </form>

  <form [formGroup]="enderecoFormGroup">
    <h1 class="text-inversu mt-4">{{'endereco' | transloco}}</h1>

    <div class="row">
      <div class="col-xl-4">
        <app-campo [formulario]="enderecoFormGroup" descricao="{{'codigo_postal_endereco' | transloco}}"
          autoPreenchimento="off" nomeControle="cep" mascara="00000-000" classe="horizontal-100"
          (alteracao)="buscaCep()" [botaoAcao]="true"></app-campo>
      </div>
      <div class="col-xl-6">
        <app-campo [formulario]="enderecoFormGroup" descricao="{{'logradouro_endereco' | transloco}}"
          autoPreenchimento="off" nomeControle="logradouro" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-2">
        <app-campo [formulario]="enderecoFormGroup" descricao="{{'numero_endereco' | transloco}}"
          autoPreenchimento="off" nomeControle="numero" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="enderecoFormGroup" descricao="{{'complemento_endereco' | transloco}}"
          autoPreenchimento="off" nomeControle="complemento" classe="horizontal-100"></app-campo>
      </div>

      <div class="col-xl-6">
        <app-campo [formulario]="enderecoFormGroup" descricao="{{'bairro_endereco' | transloco}}"
          autoPreenchimento="off" nomeControle="bairro" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="enderecoFormGroup" descricao="{{'cidade_endereco' | transloco}}"
          autoPreenchimento="off" nomeControle="cidade" classe="horizontal-100"></app-campo>
      </div>

      <div class="col-xl-3">
        <app-campo [formulario]="enderecoFormGroup" descricao="{{'estado_endereco' | transloco}}"
          autoPreenchimento="off" nomeControle="estado" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-3">
        <app-campo [formulario]="enderecoFormGroup" descricao="{{'pais_endereco' | transloco}}" autoPreenchimento="off"
          nomeControle="pais" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row mb-4 pb-4">
      <div class="col-xl-4">
        <app-botao texto="{{'atualizar' | transloco}}" [executando]="loading" classe="btn-primary horizontal-100"
          (clique)="registro()">
        </app-botao>
      </div>
    </div>

  </form>
  <form [formGroup]="dadosBancariosFormGroup">
    <h1 class="text-inversu mt-4">{{'dados_bancarios' | transloco}}</h1>

    <div class="row">
      <div class="col-xl-6">
        <div class="campo-banco">
          <label class="campo-banco-label" for="campo-banco-dropdown">{{'banco' | transloco}}</label>
          <p-dropdown inputId="campo-banco-dropdown" [options]="bancos" [(ngModel)]="bancoSelecionado"
            [ngModelOptions]="{standalone: true}" optionLabel="nome" [filter]="true" filterBy="nome,codigo"
            [showClear]="true" (onChange)="aoSelecionarBanco()" styleClass="w-full"></p-dropdown>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="dadosBancariosFormGroup" descricao="{{'agencia' | transloco}}"
          autoPreenchimento="off" nomeControle="agencia" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-6">
        <app-campo [formulario]="dadosBancariosFormGroup" descricao="{{'conta_bancaria' | transloco}}"
          autoPreenchimento="off" nomeControle="conta" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="dadosBancariosFormGroup" descricao="{{'chave_pix' | transloco}}"
          autoPreenchimento="off" nomeControle="chave_pix" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row mb-4 pb-4">
      <div class="col-xl-4">
        <app-botao texto="{{'atualizar' | transloco}}" [executando]="loading" classe="btn-primary horizontal-100"
          (clique)="registro()">
        </app-botao>
      </div>
    </div>
  </form>
  <form [formGroup]="updatePasswordFormGroup">
    <h1 class="text-inversu mt-4">{{'atualizar_senha' | transloco}}</h1>
    <div class="row">
      <div class="col-xl-6">
        <app-campo [formulario]="updatePasswordFormGroup" tipo="password" descricao="{{'nova_senha' | transloco}}"
          autoPreenchimento="nova_senha" nomeControle="nova_senha" [desabilitarAutoFill]="true"
          classe="horizontal-100"></app-campo>
      </div>

      <div class="col-xl-6">
        <app-campo [formulario]="updatePasswordFormGroup" tipo="password"
          descricao="{{'confirmar_nova_senha' | transloco}}" autoPreenchimento="confirmacao_nova_senha"
          nomeControle="confirmacao_nova_senha" classe="horizontal-100"></app-campo>
      </div>
    </div>

    <div class="row mb-4 pb-4">
      <div class="col-xl-6">
        <app-campo [formulario]="updatePasswordFormGroup" tipo="password"
          descricao="{{'confirmar_antiga_senha' | transloco}}" autoPreenchimento="senha_antiga"
          nomeControle="senha_antiga" classe="horizontal-100"></app-campo>
      </div>
      <div class="col-xl-6">
        <app-botao texto="{{'atualizar_senha' | transloco}}" [executando]="loadingUpdate"
          classe="btn-primary horizontal-100" (clique)="updatePassword()">
        </app-botao>
      </div>
    </div>
  </form>
  <div id="recaptcha-container"></div>
</div>
